/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./group-class-card.component";
var styles_GroupClassCardComponent = [".card[_ngcontent-%COMP%] {\n      border-radius: 16px;\n      overflow: hidden;\n      height: 100%;\n\n      &:hover .type-description {\n        display: block;\n      }\n    }"];
var RenderType_GroupClassCardComponent = i0.ɵcrt({ encapsulation: 0, styles: styles_GroupClassCardComponent, data: {} });
export { RenderType_GroupClassCardComponent as RenderType_GroupClassCardComponent };
export function View_GroupClassCardComponent_0(_l) { return i0.ɵvid(2, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "div", [["class", "card h-100"]], null, null, null, null, null)), i0.ɵncd(null, 0)], null, null); }
export function View_GroupClassCardComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "lp2-group-class-card", [], null, null, null, View_GroupClassCardComponent_0, RenderType_GroupClassCardComponent)), i0.ɵdid(1, 49152, null, 0, i1.GroupClassCardComponent, [], null, null)], null, null); }
var GroupClassCardComponentNgFactory = i0.ɵccf("lp2-group-class-card", i1.GroupClassCardComponent, View_GroupClassCardComponent_Host_0, {}, {}, ["*"]);
export { GroupClassCardComponentNgFactory as GroupClassCardComponentNgFactory };
//# sourceMappingURL=group-class-card.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/group-class/group-class-card/group-class-card.component.ngfactory.js
// module id = 733
// module chunks = 27 28 29